export default __webpack_public_path__ + "static/media/coi-day.08b3562d.png";